'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _intersperse = require('linksoft/utils/intersperse');

var _intersperse2 = _interopRequireDefault(_intersperse);

var _AuthorLink = require('./AuthorLink');

var _AuthorLink2 = _interopRequireDefault(_AuthorLink);

var _linksoftAlbatros = require('linksoft-albatros');

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('App');

function parseIntZero(val) {
    return parseInt(val || 0);
};

var ChooseFreeProduct = (_temp2 = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(ChooseFreeProduct, _React$PureComponent);

    function ChooseFreeProduct() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, ChooseFreeProduct);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ChooseFreeProduct.__proto__ || (0, _getPrototypeOf2.default)(ChooseFreeProduct)).call.apply(_ref, [this].concat(args))), _this), _this.handleIncrement = function (e, id, realCampaignId, productId) {
            var htmlInput = $('#gift-' + id);

            var result = _this.onAmountChanged(e, realCampaignId, productId, parseIntZero(htmlInput.val()) + 1);

            if (result) {
                htmlInput.val(parseIntZero(htmlInput.val()) + 1);
            }
        }, _this.handleDecrement = function (e, id, realCampaignId, productId) {
            var htmlInput = $('#gift-' + id);
            var htmlVal = htmlInput.val();

            var amount = parseIntZero(htmlVal);

            // if the input is empty, set amount to 1 so it's set to 0 in the next step
            if (!htmlVal) {
                amount = 1;
            }

            if (amount > 0) {
                var result = _this.onAmountChanged(e, realCampaignId, productId, amount - 1);

                if (result) {
                    htmlInput.val(amount - 1);
                }
            }
        }, _this.onChecked = function (e, realCampaignId, id, discountCampaignFreeProductId) {
            var _this$props = _this.props,
                onChange = _this$props.onChange,
                discountCampaignId = _this$props.discountCampaignId;

            if (e.target.checked) {
                onChange({ campaignId: discountCampaignId, realCampaignId: realCampaignId, selectedId: id, amount: 1, unselectedId: _this.getSelectedId() });
            } else {
                onChange({ campaignId: discountCampaignId, realCampaignId: realCampaignId, selectedId: null, unselectedId: discountCampaignFreeProductId });
            }
        }, _this.onAmountChanged = function (e, realCampaignId, id, amount) {
            var _this$props2 = _this.props,
                onChange = _this$props2.onChange,
                discountCampaignId = _this$props2.discountCampaignId;


            return onChange({ campaignId: discountCampaignId, realCampaignId: realCampaignId, selectedId: id, amount: parseIntZero(amount), unselectedId: null });
        }, _this.handleChange = function (e, currentValue, realCampaignId, id) {
            (0, _linksoftAlbatros.numbersOnly)(e);
        }, _this.handleBlur = function (e, currentValue, realCampaignId, id) {
            if (parseIntZero(currentValue) !== parseIntZero(e.target.value)) {
                var result = _this.onAmountChanged(e, realCampaignId, id, e.target.value);
                if (!result) {
                    e.target.value = currentValue;
                }
            }
        }, _this.handleKeyPress = function (e, currentValue, realCampaignId, id) {
            if (e.key === 'Enter' && parseIntZero(currentValue) !== parseIntZero(e.target.value)) {
                var result = _this.onAmountChanged(e, realCampaignId, id, e.target.value);
                if (!result) {
                    e.target.value = currentValue;
                }
            }
        }, _this.renderProduct = function (product) {
            var _this$props3 = _this.props,
                discountCampaignId = _this$props3.discountCampaignId,
                canPickMultipleFreeProductsPerCampaign = _this$props3.canPickMultipleFreeProductsPerCampaign,
                selectedProducts = _this$props3.selectedProducts,
                amountToSpend = _this$props3.amountToSpend;
            var id = product.id,
                productId = product.productId,
                productName = product.productName,
                amountAvailable = product.amountAvailable,
                authors = product.authors,
                url = product.url,
                thumbnailUrl = product.thumbnailUrl;

            var isSelected = _this.getSelectedId() === id;
            var htmlId = 'gift-' + id;
            var selectedProduct = (selectedProducts || []).find(function (x) {
                return x.discountCampaignFreeProductId === id;
            });
            var amount = selectedProduct ? selectedProduct.amount : 0;
            var amountToPurchase = Math.max(0, Math.floor(amountToSpend / product.minOrderPrice));
            var valueBox = _react2.default.createElement(
                'div',
                { className: 'gift-item__last' },
                _react2.default.createElement('button', { className: 'btn__square btn__square--minus', onClick: function onClick(e) {
                        return _this.handleDecrement(e, id, product.discountCampaignId, productId);
                    } }),
                _react2.default.createElement('input', { id: htmlId, className: 'input-nubmer-cart form-control', type: 'text',
                    defaultValue: selectedProduct ? selectedProduct.amount : 0,
                    onChange: function onChange(e) {
                        return _this.handleChange(e, amount, product.discountCampaignId, productId);
                    },
                    onBlur: function onBlur(e) {
                        return _this.handleBlur(e, amount, product.discountCampaignId, productId);
                    },
                    onKeyPress: function onKeyPress(e) {
                        return _this.handleKeyPress(e, amount, product.discountCampaignId, productId);
                    } }),
                _react2.default.createElement('button', { className: 'btn__square btn__square--plus', onClick: function onClick(e) {
                        return _this.handleIncrement(e, id, product.discountCampaignId, productId);
                    } })
            );
            var multipleSelect = _react2.default.createElement('input', { name: "gift-" + discountCampaignId, type: 'checkbox', id: htmlId, checked: isSelected, onChange: function onChange(e) {
                    return _this.onChecked(e, product.discountCampaignId, productId, product.id);
                } });
            return _react2.default.createElement(
                'div',
                { key: id, className: 'gift__item ' + (product.canPurchase ? '' : 'not-available') },
                canPickMultipleFreeProductsPerCampaign && _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'figure',
                        null,
                        _react2.default.createElement('img', { src: thumbnailUrl, alt: '' })
                    ),
                    _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'div',
                            { className: 'product__title' },
                            _react2.default.createElement(
                                'a',
                                { 'data-preview-detail': productId },
                                productName
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'product__authors' },
                            (0, _intersperse2.default)((authors || []).map(function (a) {
                                return _react2.default.createElement(_AuthorLink2.default, (0, _extends3.default)({ key: a.id }, a, { noLink: true }));
                            }), ', ')
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'small',
                                null,
                                Resx.App.Availability,
                                ':'
                            ),
                            '\xA0',
                            _react2.default.createElement(
                                'span',
                                null,
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    amountAvailable,
                                    ' ',
                                    Resx.App.Pcs
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'small',
                                null,
                                Resx.App.FreeProductsCostAvailability,
                                ':'
                            ),
                            '\xA0',
                            _react2.default.createElement(
                                'span',
                                null,
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'green' },
                                        amountToPurchase
                                    ),
                                    ' ',
                                    Resx.App.Pcs
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'small',
                                null,
                                Resx.App.UsualPrice,
                                ':'
                            ),
                            '\xA0',
                            _react2.default.createElement(
                                'span',
                                null,
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    (0, _linksoftAlbatros.formatPrice)(product.price, _linksoftAlbatros.PriceType.CartTotalPrice)
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'small',
                                null,
                                Resx.App.FreeProductsClaimPrice.replace('{0}', product.minOrderPrice)
                            )
                        )
                    ),
                    product.canPurchase && valueBox
                ),
                !canPickMultipleFreeProductsPerCampaign && _react2.default.createElement(
                    'div',
                    { className: 'gift-item--inline' },
                    product.canPurchase && multipleSelect,
                    _react2.default.createElement(
                        'label',
                        { htmlFor: htmlId },
                        _react2.default.createElement(
                            'figure',
                            null,
                            _react2.default.createElement('img', { src: thumbnailUrl, alt: '' })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'product__title' },
                            _react2.default.createElement(
                                'a',
                                { 'data-preview-detail': productId },
                                productName
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'product__authors' },
                            (0, _intersperse2.default)((authors || []).map(function (a) {
                                return _react2.default.createElement(_AuthorLink2.default, (0, _extends3.default)({ key: a.id }, a, { noLink: true }));
                            }), ', ')
                        )
                    )
                )
            );
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(ChooseFreeProduct, [{
        key: 'getSelectedId',
        value: function getSelectedId() {
            var _props = this.props,
                products = _props.products,
                selectedProducts = _props.selectedProducts;

            var selected = selectedProducts.find(function (sp) {
                return products.find(function (p) {
                    return p.id === sp.discountCampaignFreeProductId;
                });
            });
            return selected ? selected.discountCampaignFreeProductId : null;
        }
    }, {
        key: 'render',
        value: function render() {
            var products = this.props.products;

            return _react2.default.createElement(
                'div',
                { className: 'gift__items' },
                products.map(this.renderProduct)
            );
        }
    }]);
    return ChooseFreeProduct;
}(_react2.default.PureComponent), _class.propTypes = {
    canPickMultipleFreeProductsPerCampaign: _propTypes2.default.bool.isRequired,
    discountCampaignId: _propTypes2.default.number.isRequired,
    products: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
    selectedProducts: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
    onChange: _propTypes2.default.func.isRequired,
    amountToSpend: _propTypes2.default.number
}, _temp2);
exports.default = ChooseFreeProduct;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/cartDetail/step2/ChooseFreeProduct.js
// module id = 1135
// module chunks = 0